<template>
  <div class="searchBox">
    <div v-if="single" class="header single">
      <slot name="suffix"></slot>
      <div class="fg1 ova"></div>
      <div class="formItem mr10" ref="formItem">
        <slot name="default"></slot>
      </div>
      <slot name="prefix"></slot>
    </div>
    <div v-if="!single" class="header multiple" :style="{ marginBottom: none ? '0px' : '10px' }">
      <slot name="suffix"></slot>
      <div class="fg1 mr10"></div>
      <slot name="prefix"></slot>
      <el-button
        v-if="collapse"
        @click="show = !show"
        :icon="show ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"
        >{{ show ? '收起' : '展开' }}
      </el-button>
    </div>
    <div class="formItem" ref="formItem" v-if="!single">
      <slot name="default"></slot>
    </div>
  </div>
</template>

<script lang="jsx">
export default {
  name: 'searchBox',
  props: {
    single: {
      type: Boolean,
      default: false
    },
    defaultOpen: {
      type: Boolean,
      default: false
    },
    maxRows: {
      type: Number,
      default: 3
    },
    minRows: {
      type: Number,
      default: 1
    }
  },

  data() {
    return {
      defaultItemWidth: 310,
      itemWidth: 0,
      show: false,
      height: 0,
      rows: 0,
      none: false,
      collapse: false,
      loading: true,
      defaultHeight: 42,
      isCollapse: false
    };
  },
  watch: {
    '$store.getters.themeConfig': {
      handler: function (val) {
        this.defaultHeight = val && val.form ? val.form.height + 10 : this.defaultHeight;
        this.init();
      },
      deep: true,
      immediate: true
    },
    show: {
      handler(val) {
        if (val) {
          this.$nextTick(() => {
            //如果是单行直接按1计算
            if (this.single) {
              this.$refs.formItem.style.height = this.defaultHeight + 'px';
              this.$refs.formItem.style.overflow = 'hidden';
            } else {
              this.$refs.formItem.style.height = 'auto';
              this.$refs.formItem.style.maxHeight = this.maxRows * this.defaultHeight + 'px';
              this.$refs.formItem.style.overflow = 'auto';
            }
          });
        } else {
          this.$nextTick(() => {
            //如果是单行直接按1计算
            if (this.single) {
              this.$refs.formItem.style.height = this.defaultHeight + 'px';
              this.$refs.formItem.style.overflow = 'hidden';
            } else {
              this.$refs.formItem.style.height = this.minRows * this.defaultHeight + 'px';
              this.$refs.formItem.style.overflow = 'hidden';
            }
          });
        }
      },
      immediate: true
    },
    isCollapse: {
      handler(val) {
        this.init();
      }
    }
  },
  mounted() {
    this.init();
    this.listenResize();
  },
  beforeDestroy() {
    //回收监听事件
    window.removeEventListener('resize', this.debounce(this.init, 100), false);
  },

  methods: {
    //判断元素是不是有滚动条
    isScroll(el) {
      return el.scrollHeight > el.clientHeight;
    },
    /**
     * @description: 节流
     * @param {*} fn
     * @param {*} delay
     * @return {*}
     */
    debounce(fn, delay) {
      let timer = null;
      return function (...args) {
        if (timer) {
          clearTimeout(timer);
        }
        timer = setTimeout(() => {
          fn.apply(this, args);
        }, delay);
      };
    },
    listenResize() {
      window.addEventListener('resize', this.debounce(this.init, 100), false);
    },
    async init() {
      this.loading = true;
      if (this.single) {
        this.loading = false;
        return;
      }
      if (this.$refs.formItem && this.$refs.formItem.children.length > 0) {
        //如果没有日期范围选择组件 默认宽度不需要很宽
        if (this.$refs.formItem.querySelector('.el-range-editor')) {
          this.defaultItemWidth = 220;
        } else {
          this.defaultItemWidth = 178;
        }
        const formItems = this.$refs.formItem.children;
        await this.getDefaultItemWidth();
        const result = this.calcWidth();
        //分配宽度
        for (const iterator of formItems) {
          const col = iterator.getAttribute('col') || 1;
          const labelWidth = iterator.querySelector('label').getBoundingClientRect().width;
          const width = this.itemWidth * col - labelWidth + result * col - 3 + 'px';
          iterator
            .querySelector('.el-form-item__content')
            .style.setProperty('width', `${width}`, 'important');
        }
        this.$nextTick(() => {
          setTimeout(() => {
            this.calcNeedCollapse();
            this.loading = false;
          }, 0);
        });
      } else {
        this.loading = false;
      }
      this.height = this.minRows * this.defaultHeight + 10;
    },
    /**
     * @description: 计算分配的剩余空间
     * @return {*}
     */
    calcWidth() {
      const formItems = this.$refs.formItem.children;
      //给幽灵节点留点空间
      let width = this.$el.clientWidth;
      let count = Math.floor(Number(width) / this.itemWidth);

      // 计算所有formItem的总列数
      let totalCols = 0;
      for (const item of formItems) {
        const col = Number(item.getAttribute('col')) || 1;
        totalCols += col;
      }

      // 如果一行能放下的列数大于实际总列数,则以实际总列数为准
      if (count > totalCols) {
        count = totalCols;
      }

      width = width - count * 2;
      //滚动条宽度
      const scrollWidth = 20;
      const remainWidth = Number(width) - this.itemWidth * count - scrollWidth;
      return isNaN(parseInt(remainWidth / count)) ? 0 : parseInt(remainWidth / count);
    },
    /**
     * @description: 获取默认formitem宽度
     * @return {*}
     */
    getDefaultItemWidth() {
      return new Promise((resolve) => {
        setTimeout(() => {
          const labelWidth = this.$refs.formItem
            .querySelector('label')
            .getBoundingClientRect().width;
          this.itemWidth = labelWidth + this.defaultItemWidth;
          resolve();
        }, 30);
      });
    },
    /**
     * @description: 判断是否需要收起按钮
     * @return {*}
     */
    calcNeedCollapse() {
      if (this.$refs.formItem.children.length === 0) {
        this.collapse = false;
      } else if (this.$refs.formItem.children.length > 0) {
        const ele = this.$el.getBoundingClientRect();
        const lastFormItem = this.$refs.formItem.children
          .item(this.$refs.formItem.children.length - 1)
          .getBoundingClientRect();
        //如果父元素的 y+高 > 子元素的 y+高 说明不需要折叠
        if (ele.y + ele.height > lastFormItem.y + lastFormItem.height) {
          this.collapse = false;
        } else {
          this.collapse = true;
          //增加默认展开
          if (this.defaultOpen) {
            this.$nextTick(() => {
              this.show = this.defaultOpen;
            });
          }
        }
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.searchBox {
  padding: 10px 10px 0px;
  overflow: hidden;
  transition: all 0.3s linear;
  .header {
    display: flex;
    align-items: flex-start;
  }
  .single {
    .formItem {
      flex-grow: 1;
      display: flex;
      flex-wrap: nowrap;
      justify-content: flex-end;
      align-items: center;
    }
  }
  .multiple {
    .formItem {
      display: flex;
      flex-wrap: wrap;
      width: 100%;
    }
  }
}
::v-deep .el-form-item {
  margin-bottom: 10px !important;
  margin-right: 0px !important;
}

::v-deep .el-form-item__content {
  width: 100% !important;
}
::v-deep .el-input__inner {
  width: 100% !important;
}
::v-deep .el-input {
  width: 100% !important;
}
::v-deep .el-form-item__content {
  margin-right: 0px !important;
}
::v-deep .el-select {
  width: 100% !important;
}

// single模式下的特殊样式
.single {
  align-items: center !important;
  margin-bottom: 10px;
  ::v-deep .el-form-item {
    display: flex;
    align-items: center;
    margin-bottom: 0 !important;
    flex-shrink: 0;
  }

  ::v-deep .el-form-item__content {
    width: auto !important;
    flex-shrink: 0;
  }

  ::v-deep .el-input,
  ::v-deep .el-select {
    width: auto !important;
    min-width: 180px;
  }
}
</style>
